import { memo } from 'react';
import { AlertTriangle } from 'lucide-react';
import { BaseNode, type NodeData } from './BaseNode';

function ChallengeNodeComponent({ data, selected }: { data: NodeData; selected?: boolean }) {
  return <BaseNode data={data} selected={selected} icon={AlertTriangle} nodeType="challenge" />;
}

export const ChallengeNode = memo(ChallengeNodeComponent);
